// extracted by css-extract-rspack-plugin
export default {"cls1":"CitationGenerator-cls1_ar1","cls2":"CitationGenerator-cls2_7wW CitationGenerator-cls1_ar1"};